import React, { useState } from "react";
import styled from "styled-components";
import { useInView } from "react-hook-inview";
import { motion } from "framer-motion";

const LoadInViewStyle = styled.div`
  position: relative;
`;

const LoadInView = ({ children, id }) => {
  const [ref, inView] = useInView({
    unobserveOnEnter: true,
    rootMargin: "10px",
    threshold: 0,
  });
  // 처음부터 확정해 둔다. true로 시작했다가 effect에서 false로 바꾸면 감싸는 태그가
  // 사라지면서 children이 다시 마운트되어 API를 다시 부른다(본문 깜빡임).
  const [animations] = useState(
    () => !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );

  if (!animations) return children;

  // 감싸는 태그를 inView 전후로 바꾸면(div → section) React가 children을 통째로
  // 다시 만들어서, 안에서 불러온 데이터가 날아가고 API를 다시 부른다(본문이 깜빡임).
  // 태그는 그대로 두고 animate 값만 바꾼다.
  return (
    <LoadInViewStyle ref={ref} id={id} className="load-in-view">
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{
          duration: 0.7,
          ease: "easeInOut",
        }}
      >
        {children}
      </motion.section>
    </LoadInViewStyle>
  );
};

export default LoadInView;
